import React, { useMemo } from 'react';
import { Box, Text } from '@common-fe/common-fe';
import { toNumber } from 'lodash';

import { LockboxValidationError, lockboxValidationErrorTitle } from '@/modules/employer/components/Lockbox/lockbox.types';
import { MatchingListWrapper } from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxMatchingList';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';
import { formatCurrency } from '@/utils';

import AllEmployeeClaims from './AllEmployeeClaims';
import CreatedClaimRepayments from './CreatedClaimRepayments';
import ManualSearchLockboxClaims from './ManualSearchLockboxClaims';
import SuggestedLockboxClaims from './SuggestedLockboxClaims';

const SelectLockboxClaims = () => {
  const { originalLockbox, editableLockbox, validationErrors } = useLockboxDetailsStore();

  const hasCreatedRepaymentAmount = useMemo(() => !!originalLockbox?.createdClaimRepayments?.length,
    [originalLockbox?.createdClaimRepayments]);

  const remainder = useMemo(() => {
    const value = toNumber(originalLockbox?.amount || 0) - (editableLockbox?.totalAllocated || 0);
    return Math.round(value * 100) / 100;
  }, [originalLockbox?.amount, editableLockbox?.totalAllocated]);

  const errorType = useMemo(() => {
    return validationErrors?.find((error) => error === LockboxValidationError.CLAIM_REQUIRED
    || error === LockboxValidationError.CLAIMS_MUST_HAVE_THE_SAME_EMPLOYEE
    || error === LockboxValidationError.TOTAL_ALLOCATED_EXCEEDED) as LockboxValidationError | undefined;
  }, [validationErrors]);

  return (
    <MatchingListWrapper
      title="Claims"
      testId="select-claims"
      {...errorType ? { errorText: lockboxValidationErrorTitle?.[errorType]} : {}}
      isErrorTopPosition
      headerChildren={(
        <Box margin={{ left: 'auto' }} direction="row">
          <Box direction="row">
            <Text color="textSecondary" style={{ whiteSpace: 'break-spaces' }}>
              Total allocated:{' '}
            </Text>
            <Text weight={700}>
              {formatCurrency(editableLockbox?.totalAllocated || 0)}
            </Text>
          </Box>

          <Box margin={{ left: 'spacing12' }} direction="row">
            <Text color="textSecondary" style={{ whiteSpace: 'break-spaces' }}>
              Remainder:{' '}
            </Text>
            <Text weight={700}>
              {formatCurrency(remainder)}
            </Text>
          </Box>
        </Box>
      )}
    >
      {hasCreatedRepaymentAmount && (
        <Box margin={{ bottom: 'spacing24' }}>
          <CreatedClaimRepayments />
        </Box>
      )}

      <SuggestedLockboxClaims />

      <Box margin={{ top: 'spacing24' }}>
        <ManualSearchLockboxClaims />
      </Box>

      <Box margin={{ top: 'spacing24' }}>
        <AllEmployeeClaims />
      </Box>
    </MatchingListWrapper>
  );
};

export default SelectLockboxClaims;
